import classes from "./premiumPlansHeader.module.css";
import { isMobileDevice } from "../../services/utils";

const SubHeading = () => {
  return (
    <div className={classes.subHeading}>
      Buy Job Hai
      <img
        src="/hire/coin-icon.svg"
        alt="coin"
        height={"25px"}
        width={"25px"}
        className={classes.coin}
      />
      Credits to hire faster using Premium Jobs. Select a plan that fits your
      hiring requirements
    </div>
  );
};

const PremiumPlansPageHeader = props => {
  return (
    <>
      <div className={classes.headerCnt}>
        <div className={classes.h1Cnt}>
          <img src="/hire/pink-diamond.svg" alt="pink diamond" />
          <h1> Premium Job</h1>
        </div>
        {!isMobileDevice() && <SubHeading />}
        <div
          className={`flex items-center justify-center md:hidden ${classes.tagCnt}`}
        >
          <span>
            <img src="/hire/flash.svg" alt="flash" />
          </span>
          <span className={classes.tag}>FOR HIRING FASTER</span>
        </div>
        {isMobileDevice() && (
          <div className={classes.subHeading}>
            Buy Job Hai Credits to hire faster using Premium Jobs
          </div>
        )}
      </div>
    </>
  );
};
export default PremiumPlansPageHeader;
